import { render, staticRenderFns } from "./modal-client.vue?vue&type=template&id=22faa250&scoped=true"
import script from "./modal-client.vue?vue&type=script&lang=js"
export * from "./modal-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22faa250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22faa250')) {
      api.createRecord('22faa250', component.options)
    } else {
      api.reload('22faa250', component.options)
    }
    module.hot.accept("./modal-client.vue?vue&type=template&id=22faa250&scoped=true", function () {
      api.rerender('22faa250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabClients/modal-client.vue"
export default component.exports